<template>
  <section class="ufw-section">
    <h3>Ufw 节点内存</h3>

    <el-tabs v-model="tabNodeGroup" type="border-card" @tab-click="handleTabNodeGroupClick" style="padding: 0;margin: 0 0 10px">
      <el-checkbox :indeterminate='isIndeterminate' v-model='checkAll' @change='handleCheckAllChange'>全选</el-checkbox>
      <el-tab-pane :label="item.groupKey" :name="item.groupKey" v-for="(item, i) in groupNodes" :key="i">
        <el-row v-if="nodeOption.length > 0">
          <el-col :span="6">
            <el-checkbox-group v-model='nodeList' @change='handleCheckedCitiesChange' style="display: flex;flex-direction: column;justify-content: space-between">
              <el-checkbox v-for='item in nodeOption' :label='item' :key='item' style="margin-top: 5px"></el-checkbox>
            </el-checkbox-group>
          </el-col>
          <el-col :span="6">
            <el-popconfirm style="margin-left: 10px;" icon="el-icon-warning" title="你确定要让服务端立即生效么？" @confirm="handleUfwReload">
              <el-button slot="reference" type="danger" size="small">重载</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-card class="ufw-card">
      <div slot="header" class="ufw-card-header">
        <div class="header-title">
          <span>节点列表</span>
        </div>
        <template v-for="(item, index) in nodeOption">
          <el-radio v-model="nodeHost" :label="item" :key="index" @input="onNodeInput"></el-radio>
        </template>
      </div>

      <div class="ufw-content">
        <el-tabs v-model="scopeType" @tab-click="onTabsClick">
          <template v-for="(item, index) in scopeOption">
            <el-tab-pane :key="index" :name="item.value">
              <span slot="label" style="margin: 0 10px;"> {{item.label}} </span>
              <template v-for="(item, index) in ufwOption">
                <el-radio v-model="ufwType" :label="item.value" :key="index">
                  <!-- @input="onUfwSearch(item)" -->
                  {{item.label}}
                </el-radio>
              </template>

              <el-button type="primary" size="small"  @click="onUfwSearch()">查看</el-button>
            </el-tab-pane>
          </template>
        </el-tabs>
        <TableComponents
          :tableData="tableData"
          :column="getColumn"
        >
          <!-- <template slot="slotTest" slot-scope="{row, column}" >
          </template> -->
        </TableComponents>
      </div>
    </el-card>
  </section>
</template>

<script>
import api from '@/api/channel'
import TableComponents from './components/Table'
import { column } from './table'
export default {
  name: 'ufwIndex',
  components: {
    TableComponents
  },
  data: function () {
    return {
      radio: 1,
      tabNodeGroup: '',
      groupNodes: [],
      nodeOption: [],
      nodeList: [],
      nodeHost: '',
      checkAll: true, // 全选
      isIndeterminate: false,
      tableData: [],
      scopeType: '1',
      scopeOption: [
        { id: 1, label: '封禁', value: '1' },
        { id: 2, label: '充值', value: '2' },
        { id: 3, label: '注册', value: '3' }
      ],
      ufwType: '1',
      ufwList: {}
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    getColumn () {
      return column
    },
    ufwOption () {
      return [
        { id: 1, label: '黑名单', value: '1', request: api.ufwBlacklists },
        { id: 3, label: '白名单', value: '3', request: api.ufwWhitelists }
      ]
    }
  },
  mounted: function () {
    this.initFetch()
  },
  methods: {
    initFetch () {
      this.groupNodes = []
      api.getNodeList({ appId: this.appId, format: 'group' }).then(res => {
        if (res.length <= 0) {
          return
        }
        this.groupNodes = res
        const gn = res.find(d => d.selected) || res[0]
        this.tabNodeGroup = gn.groupKey
        this.nodeOption = gn.nodes
        this.nodeHost = gn.nodes[0]
        this.handleCheckAllChange(true)
      })
      this.channelOptions = []
      api.getChannelData(this.appId).then(res => {
        this.channelOptions = Object.assign([], res)
      })
    },
    // 节点列表页签切换
    handleTabNodeGroupClick () {
      const gn = this.groupNodes.find(d => d.groupKey === this.tabNodeGroup) || this.groupNodes[0]
      this.nodeOption = gn.nodes
      this.nodeHost = gn.nodes[0]
      this.handleCheckAllChange(true)
    },
    // 全选
    handleCheckAllChange (val) {
      this.nodeList = val ? this.nodeOption : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.nodeOption.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.nodeOption.length
      this.visible = false
    },
    handleUfwReload () {
      if (!this.nodeList.length) {
        return this.$message.info('请选择节点')
      }
      for (const item of this.nodeList) {
        api.ufwReload({
          host: item
        }).then(() => {
          console.log(item + ': success')
        })
      }
      this.tableData = []
      this.$message.warning('重载成功 !')
    },
    onUfwSearch (item) {
      let target = item
      if (!target) {
        target = this.ufwOption.find(item => +this.ufwType === +item.value)
      }
      const loading = this.$loading({
        target: document.querySelector('.ufw-section')
      })
      target.request({ host: this.nodeHost, type: +this.scopeType }).then(res => {
        this.tableData = res.data ?? []
      }).finally(() => loading.close())
    },
    onNodeInput () {
      // this.onUfwSearch()
      // this.ufwType = ''
    },
    onTabsClick () {
      // this.onUfwSearch()
      // this.ufwType = ''
    }
  }
}
</script>

<style scoped>
.ufw-section h3 {
  margin-left: 4px;
}
.el-card__header {
  border-bottom-width: 0;
}
.header-title {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 14px;
}
.header-title span {
  margin-right: 10px;
}
::v-deep.ufw-section .el-radio__input {
  line-height: 12px;
}

::v-deep.ufw-section .el-tabs__item.is-active {
  /* transform: scale(1.08); */
  font-weight: 600;
}

.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.align-center {
  align-items: center;
}
.align-end {
  align-items: flex-end;
}
</style>
